module.exports = __webpack_public_path__ + "static/media/local_bar.29c04e9e.svg";